import { localStorageKeys } from "./constants";

const getAPIAddrPL = () => {
  return window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : "https://cr.vean-tattoo.pl";
};

const getSelectedCoutryCode = () =>
  localStorage.getItem(localStorageKeys.selectedCountry) || "com";

const getAPIByCode = (code) => {
  return window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : `https://cr${code === "pl" ? "" : "m"}.vean-tattoo.${code}`;
};

const getHasuraDomain = () => {
  const selectedCountryCode = getSelectedCoutryCode();
  return window.location.hostname === "localhost"
    ? "http://localhost:8080/v1/graphql"
    : `https://${
        ["pl", "lv"].includes(selectedCountryCode) ? "gq" : "gql"
      }.vean-tattoo.${selectedCountryCode}/v1/graphql`;
};

const BASE_APIURL =
  window.location.hostname === "localhost"
    ? "http://localhost:8000/api"
    : "https://cr.vean-tattoo.pl/api";

export {
  getAPIAddrPL,
  getHasuraDomain,
  getAPIByCode,
  BASE_APIURL,
  getSelectedCoutryCode,
};
